require('custom/gtm-datalayer');
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

custom.pdpRugDriver = (function () {
  const selectorClassName = 'js-variant-select';
  const rugPadDriverClassName = 'js-rug-pad-driver';
  const rugPadOption = 'select.js-rug-pad-select > option';
  const rugPadTitle = '.js-pad-title';

  //select 2
  const defaultPlaceholder = 'Select an Option';
  const rugPadSelectID = '#pdp-rug-pad';
  const rugPadSelectInitClass = 'js-rug-pad-select2--initialized';
  const loadingId = 'Loading...';
  const extraOptionId = 'hidden value';
  const jsLoadingOptionId =
    '.js-rug-pad-select2  .select2-disabled.js-loading-option';
  let rugPadSelect2 = null;

  //const productDetailsClass = '.product-detail__content';
  //const rugPadActiveClass = 'rugpad-active';
  const loggedIn = window.tier_price_info.customer_id !== '' ? true : false;

  const gtmData = {
    event: 'GAEvent',
    eventCategory: 'Product Detail',
    eventAction: '',
    eventLabel: '',
  };

  function getPrices() {
    //TOOD: should cache this as its the same for every PDP
    $(rugPadOption).each(function () {
      let formattedPrice = '';
      if (loggedIn) {
        const variantId = parseInt($(this).data('variant-identifier'));
        const newPrice = custom.utils.getVariantPriceById(variantId);
        formattedPrice = slate.Currency.formatMoney(
          newPrice,
          '${{ amount_no_decimals }}',
        );
      }
      $(this).first().text(formattedPrice);
    });
  }

  function getOptionSize(optionSizeRaw, handle = '') {
    let optionSize = optionSizeRaw.replace(/'/g, '');
    switch (optionSize) {
      case '2 x 3':
        optionSize = '2\'-0" x 4\'-0"';
        break;
      case '4 x 6':
        optionSize = '4\'-0" x 6\'-0"';
        break;
      case '5 x 8':
        optionSize = '5\'-0" x 8\'-0"';
        break;
      case '6 x 9':
        optionSize = '6\'-0" x 9\'-0"';
        break;
      case '8 x 10':
        optionSize = '8\'-0" x 10\'-0"';
        break;
      case '9 x 12':
        optionSize = '9\'-0" x 12\'-0"';
        if (handle == 'outdoor-grip-rug-pad-beige')
          optionSize = '8\'-0" x 10\'-0"';
        break;
      case '10 x 14':
        optionSize = '10\'-0" x 14\'-0"';
        break;
      case 'oversized':
        optionSize = '12\'-0" x 15\'-0"';
        if (handle == 'outdoor-grip-rug-pad-beige')
          optionSize = '10\'-0" x 14\'-0"';
        break;
      case '12 x 15+':
        optionSize = '12\'-0" x 15\'-0"';
        break;
      case '2.6 x 8':
        optionSize = '2\'-0" x 8\'-0"';
        break;
      case '2.6 x 10':
        optionSize = '2\'-0" x 8\'-0"';
        break;
      case '8 runner':
        optionSize = '2\'-0" x 8\'-0"';
        break;
      case '10 runner':
        optionSize = '2\'-0" x 8\'-0"';
        break;
      case '12 runner':
        optionSize = '2\'-0" x 12\'-0"';
        break;
      case '14+ runner':
        optionSize = '2\'-0" x 12\'-0"';
        break;
      default:
        optionSize = null;
        break;
    }
    return optionSize;
  }

  function onChangeHandler(e) {
    let rugPadAvail = false;
    let optionSize = $(e.currentTarget)
      .find('option:selected')
      .data('option')
      .toLowerCase();

    //reset the select box
    //$(rugPadCheckbox).prop('checked', false);
    $(rugPadSelectID).empty();
    $(rugPadSelectID).removeClass(rugPadSelectInitClass);
    if (rugPadSelect2) {
      rugPadSelect2.select2('destroy');
      rugPadSelect2.off('select2:open');
      rugPadSelect2.off('select2:close');
      rugPadSelect2 = null;
    }
    //remove price from button
    calculatePrice();

    let optionSizeRugPad = getOptionSize(optionSize);
    //if no matching size, skip
    if (optionSizeRugPad !== null) {
      //find relevant size for each rugpad type and add it to select box
      //loop through each rugpad type and match the size
      let first = true;
      $(rugPadOption).each(function () {
        if (optionSizeRugPad != $(this).data('size')) return;
        if (first) {
          first = false;
          $(rugPadSelectID).append(
            '<option selected hidden disabled class="select2-disabled js-loading-option">Loading...</option>',
          );
          $(rugPadSelectID).append(
            '<option class="hidden" disabled>hidden value</option>',
          );
          $(rugPadSelectID).append(
            '<option value="no-rug-pad" data-title="No Rug Pad" data-description="Choosing no rug pad? Consider adding one later.">No Rug Pad</option>',
          );
          showRugPad();
          rugPadAvail = true;
          //store current size with see all button
          $('.js-rug-pad-driver .js-quick-view-button').data(
            'size',
            optionSizeRugPad,
          );
        }
        //copy option to the rug pad select
        $(rugPadSelectID).append($(this).clone());
      });
      //trigger select 2 update
      $(rugPadSelectID).each(customizeSelect);
    }
    if (!rugPadAvail) {
      hideRugPad();
    }
  }

  function getVariantTemplateObj(
    state = null,
    isSelectedState = false,
    notAuth = false,
  ) {
    if (!state || !state.element) return;
    // get select title
    let title = state.element.text;
    // if we're not logged in there will be no price
    // if there is a price and a size - make title the title + size
    if (
      (title.indexOf('$') >= 0 || !loggedIn) &&
      $(state.element).data('size')
    ) {
      let size = $(state.element).data('size');
      title =
        custom.utils.titleCase(state.element.dataset.title) + ' — ' + size;
    }
    const variant_id = state.element.dataset.variant_id;
    const variant_price = !notAuth && variant_id ? state.element.text : null;
    const isNoRugPad = state.element.value === 'no-rug-pad';

    let $price = variant_price
      ? `<span class="select2-results__price">${variant_price}</span>`
      : isSelectedState || isNoRugPad
      ? ''
      : '<span class="select2-results__price select2-results__price--unauth">Sign in For Pricing</span>';

    if (
      !isSelectedState &&
      !isNoRugPad &&
      state.element.dataset.price &&
      state.element.dataset.price === 'Contact For Pricing'
    )
      $price =
        '<span class="select2-results__price select2-results__price--unauth">Contact For Pricing</span>';

    const $label = state.element.dataset.label
      ? `<span class="select2-results__label"><span class="pill pill--tight">${state.element.dataset.label}</span></span>`
      : '';
    const $description = `<span class="select2-results__description">${state.element.dataset.description}</span>`;

    return {
      title,
      $price,
      $label,
      $description,
      variant_price,
    };
  }

  function optionTemplate(isSelectedState = false, notAuth = false) {
    return function templateString(state) {
      if (!state.id || !state.element) {
        return $(
          '<span class="select2-results__option-row"><span class="select2-results__title select2-results__title--select truncate">Select Rug Pad Style</span></span>',
        );
      }
      if (state.loading) return state.text;
      if (state.id == loadingId || state.id == extraOptionId) {
        $(`li[id*='${loadingId}']`).remove();
        return;
      }
      const variant = getVariantTemplateObj(state, isSelectedState, notAuth);

      if (isSelectedState) {
        return $(
          `<span class="select2-results__option-row justify-center flex-col ${
            variant.title != 'Select Rug Pad Style' ? 'select2-rugpad' : ''
          }">
            <span class="flex flex-row justify-between">
              <span class="select2-results__title ${
                variant.title != 'Select Rug Pad Style'
                  ? 'select2-results__title--selected'
                  : ''
              }">${variant.title}</span>
              ${variant.$price}
            </span>
          </span>`,
        );
      } else {
        return $(
          `<span class="flex flex-col gap-y-2 my-2 select2-rugpad">
            ${variant.$label}
            <span class="flex flex-row justify-between">
              <span class="select2-results__title">${variant.title}</span>
              ${variant.$price}
            </span>
            ${variant.$description}
          </span>`,
        );
      }
    };
  }

  function customizeSelect(index = 0, selector = null) {
    if ($(selector).hasClass(rugPadSelectInitClass)) return;
    const $variants = $(selector).children('option');
    const placeholder = $(selector).data('placeholder') || defaultPlaceholder;
    const notAuth =
      $(selector).data('authorized') &&
      $(selector).data('authorized') === 'unauthorized';
    const notLoggedIn =
      $(selector).data('customer') &&
      $(selector).data('customer') === 'noncustomer';

    $variants.each((index, variant) => {
      // If logged in, hide prices
      if (
        $(selector).data('customer') &&
        $(selector).data('customer') === 'noncustomer'
      ) {
        variant.setAttribute('data-price', ' ');
        variant.setAttribute('data-unauth', 'true');
      }
    });

    // Converts Promises Object to Array
    const hidePrices = notAuth || notLoggedIn;

    // Update loading text
    if ($(`${jsLoadingOptionId}`).length)
      $(`${jsLoadingOptionId}`).html('Select Rug Pad Style');

    // Initialize Select2
    const templateResult = optionTemplate(false, hidePrices);
    const templateSelection = optionTemplate(true, hidePrices);

    rugPadSelect2 = $(selector)
      .select2({
        width: 'style',
        minimumResultsForSearch: Infinity,
        templateResult,
        templateSelection,
        placeholder: placeholder,
      })
      .maximizeSelect2Height({cushion: 50});
      
    rugPadSelect2
      .on('select2:open', function (e) {
        $('body > .select2-container--default').addClass('opened');
        // insert content into the select box
        // message changes if indoor/outdoor
        if (!$('#rugpad-disclaimer').length) {
          const indoor = $('#pdp-rug-pad').data('indoor');
          const disclaimer = indoor
            ? ' <br>Rug pads are recommended for indoor or covered outdoor use.'
            : '';
          $('ul.select2-results__options').after(
            `<div id="rugpad-disclaimer" class="block p-4 bg-grey utility-xsmall text-center surface-subtle border-b border-subtle">All pads are easy to trim, ensuring a perfect fit.${disclaimer}</div>`,
          );
        }
        // Lock body Element on mobile
        if ($(window).width() < 768) {
          disableBodyScroll(
            document.querySelector(
              'body > .select2-container--default .select2-dropdown',
            ),
            {
              allowTouchMove: (el) => {
                while (el && el !== document.body) {
                  if (el.getAttribute('body-scroll-lock-ignore') !== null) {
                    return true;
                  }

                  el = el.parentElement;
                }
              },
            },
          ); // Lock body Element
          //show overlay
          $('.js-modal-overlay').show();
        }
      })
      .on('select2:closing', function (e) {
        $('body > .select2-container--default').removeClass('opened');
        // UnLock body Element on mobile
        if ($(window).width() < 768) {
          clearAllBodyScrollLocks();
          //hide overlay
          $('.js-modal-overlay').hide();
        }
      })
      .on('select2:select', function (e) {
        if (e.params && e.params.data && e.params.data.id === 'no-rug-pad') {
          // "No Rug Pad" selection - clear <select> value but show selext2 as "no rug pad"
          $(selector).val(null);
          $(selector)
            .next('.select2-container')
            .find('.select2-selection__rendered')
            .html(
              '<span class="select2-results__option-row justify-center flex-col select2-rugpad"><span class="flex flex-row justify-between"><span class="select2-results__title select2-results__title--selected">No Rug Pad</span></span></span>',
            );
          calculatePrice();
          return;
        }
        calculatePrice(e);
      });
    $(selector).addClass(rugPadSelectInitClass);
  }

  function oakHandler() {
    //find relevant size for each rugpad type and add it to select box
    //loop through each rugpad type and match the size
    let first = true;
    $(rugPadOption).each(function () {
      if (first) {
        first = false;
        $(rugPadSelectID).append(
          '<option selected hidden disabled class="select2-disabled js-loading-option">Loading...</option>',
        );
        $(rugPadSelectID).append(
          '<option class="hidden" disabled>hidden value</option>',
        );
        $(rugPadSelectID).append(
          '<option value="no-rug-pad" data-title="No Rug Pad" data-description="Choosing no rug pad? Consider adding one later.">No Rug Pad</option>',
        );
        showRugPad();
      }
      //copy option to the rug pad select
      $(rugPadSelectID).append($(this).clone());
    });
    //trigger select 2 update
    $(rugPadSelectID).each(customizeSelect);
  }

  function showRugPad() {
    if ($(`.${rugPadDriverClassName}`).hasClass('hidden')) {
      $(`.${rugPadDriverClassName}`).removeClass('hidden');
      //$(`${productDetailsClass}`).addClass(`${rugPadActiveClass}`);
      gtmData.eventAction = 'Rug Pad Shown';
      gtmData.eventLabel =
        $('.rug-pad__wrapper h3').text() + ' - ' + $(rugPadTitle).text();
      custom.gtmDatalayer.gtmPush(gtmData);
    }
  }

  function hideRugPad() {
    if (!$(`.${rugPadDriverClassName}`).hasClass('hidden')) {
      $(`.${rugPadDriverClassName}`).addClass('hidden');
      //$(`${productDetailsClass}`).removeClass(`${rugPadActiveClass}`);
    }
  }

  function rugDriverHandler() {
    if ($('.is-oak-rug-pad').length > 0) return oakHandler();
    $(`.${selectorClassName}`).on('change', (e) => {
      onChangeHandler(e);
    });
  }

  function checkHandler(e) {
    const label = $('.js-add-rug-pad-label');
    const checked = e.currentTarget.checked;
    if (checked == false || checked == 'false') {
      label.text('Add Rug Pad');
      //remove price from button
      calculatePrice();
    } else {
      gtmData.eventAction = 'Rug Pad Checked';
      gtmData.eventLabel =
        $('.rug-pad__wrapper h3').text() + ' - ' + $(rugPadTitle).text();
      custom.gtmDatalayer.gtmPush(gtmData);
      label.text('Remove Rug Pad');
      //add price to button
      calculatePrice();
    }
  }

  function calculatePrice() {
    //if a variant is selected, grab its price and append to add to cart form
    const price =
      $(`.${rugPadDriverClassName}`)
        .closest('form')
        .find('.select2-selection__rendered .select2-results__price')
        .text()
        .indexOf('$') >= 0
        ? $('.select2-selection__rendered .select2-results__price').text()
        : '';
    if (price) {
      let qty = $(`.${rugPadDriverClassName}`)
        .closest('form')
        .find('select[name="quantity"]')
        .val();
      let subtotal =
        parseFloat(price.replace('$', '').split(',').join('')) * Number(qty);
      //see if a rug pad has been selected or not
      let rugpadPrice =
        $(`.${rugPadDriverClassName}`)
          .find('.select2-selection__rendered .select2-results__price')
          .text()
          .indexOf('$') >= 0
          ? $(`.${rugPadDriverClassName}`)
              .find('.select2-selection__rendered .select2-results__price')
              .text()
          : '';
      if (!$(`.${rugPadDriverClassName}`).hasClass('hidden') && rugpadPrice) {
        subtotal +=
          parseFloat(rugpadPrice.replace('$', '').split(',').join('')) *
          Number(qty);
      }
      let formattedprice = slate.Currency.formatMoney(
        subtotal.toFixed(2),
        '${{ amount_no_decimals }}',
      );
      addToCartPrice(
        formattedprice,
        $(`.${rugPadDriverClassName}`).closest('form'),
      );
    }
  }

  function addToCartPrice(price, $form) {
    $form
      .find('.pdp-add-button')
      .html(
        `<div class="flex spacer-0--gap-x justify-center">Add to cart <span class="content-disabled">|</span> ${price}</span>`,
      );
  }

  function init() {
    rugDriverHandler();
    if (loggedIn) {
      $(window).on('load', function () {
        getPrices();
      });
    }
  }

  return {
    init,
    getOptionSize,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/pdp-rug-driver.js